module.exports = __webpack_public_path__ + "img/theTitle.8b7b9c75.png";